export default __webpack_public_path__ + "static/media/Software.73262de4.png";